// select the correct language here
import language from "./../../src/common/i18n/nl_BE.json";

const dictionary = language;
// if needed change some strings here or add some
dictionary.Promospot = "BIJLAGES";
dictionary.supplements = "Bijlagen";
dictionary.Archive = "VORIGE EDITIES";
dictionary.HorsSeries = "EXTRA’S";
dictionary.E24 =
  "Uw account geeft geen toegang tot de digitale krant. Surf naar tijd.be/abonnement en upgrade om toegang te krijgen.";
dictionary.accountLoggedInInfo = "U bent momenteel ingelogd";
dictionary.accountLoggedWithInfo = "U bent momenteel ingelogd met";
export default dictionary;



// WEBPACK FOOTER //
// ./clients/mfn-tij/dictionary.js